import { Navigate } from 'react-router-dom';

import StoresList from '~/UI/components/organisms/StoresList';
import FullPageLoader from '~/UI/components/templates/FullPageLoader';
import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { useEstimateContext } from '~/legacy/easy-estimator-page/context/estimateContext';
import { useAppSelector } from '~/redux/hooks';
import { selectLoadEstimateCode } from '~/redux/slices/estimate';
import { RouteEnum } from '~/redux/slices/route/route.types';

const StorePage = (): JSX.Element => {
  const { isFetchingEstimate, fetchedEstimate } = useEstimateContext();
  const loadEstimateCode = useAppSelector(selectLoadEstimateCode);
  const loadEstimateParam = new URL(window.location.href).searchParams.get(
    LOCAL_STORAGE_KEY.LOAD_ESTIMATE
  );

  if (loadEstimateParam && !fetchedEstimate) {
    return (
      <Navigate
        to={`${RouteEnum.THANK_YOU}?${LOCAL_STORAGE_KEY.LOAD_ESTIMATE}=${loadEstimateParam}`}
        replace
      />
    );
  }

  if (isFetchingEstimate) {
    return <FullPageLoader />;
  }

  return <StoresList disabled={!!loadEstimateCode} />;
};

export default StorePage;
